<template lang="pug">
.collection-list-item
  article.card.is-paddingless(:class="{ 'is-hoverable': hoverable }")
    .card-image
      router-link(:to="{ name: 'collection', params: { id: collection.id } }")
        b-icon.play-icon(icon="play-circle-outline" size="is-large")
        figure.image.is-16by9
          cl-img(
            :cl-id="collection._embedded.artwork.cl_id"
            :transform="{ width: 640, height: 360 }"
          )
    .card-content
      .card-grow
        .card-title
          p.main {{ collection.title | truncate(55) }}
          .sub(v-if="speakers.length === 1")
            speaker-tag(:value="speaker")
          .sub(v-else-if="speakers.length > 1")
            span Multiple speakers
        .card-desc(@click="redirect")
          p {{ collection.long_desc }}
      .card-meta
        .level.is-mobile
          .level-left
            .level-item {{ collection.start_date | date('YYYY') }}
            .level-item {{ collection.episode_count }} {{ sermonLabel }}
</template>

<script>
import SpeakerTag from '@/components/speakers/SpeakerTag.vue';

export default {
  name: 'collection-list-item',
  components: {
    SpeakerTag,
  },
  computed: {
    collection() {
      return this.value;
    },
    sermonLabel() {
      return this.value.episode_count === 1 ? 'sermon' : 'sermons';
    },
    speaker() {
      return this.speakers[0];
    },
    speakers() {
      return this.value._embedded.speakers || [];
    },
  },
  methods: {
    redirect() {
      this.$router.push({
        name: 'collection',
        params: {
          id: this.collection.id,
        },
      });
    },
  },
  props: {
    hoverable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.collection-list-item {
  @include listItem;
  .sub {
    margin-top: 0.5rem;
  }
}
</style>
